module.exports = __webpack_public_path__ + "media/img/favicon/android-chrome-48x48-cac1b637d57c7774f8b24666c31e677c.png";